(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/tabbed/assets/javascripts/client-route.js') >= 0) return;  svs.modules.push('/templates/tabbed/assets/javascripts/client-route.js');
"use strict";


const menuItems = Array.prototype.slice.call(document.querySelectorAll(".".concat(svs.tabsConfig.data.tabsConfig.uniqueClass, " .js-items-menu-item")));
const links = menuItems.map(link => ({
  el: link,
  href: link.getAttribute('href')
}));
if (links.length) {
  const itemsMenu = new svs.ui.ItemsMenu({
    class: svs.tabsConfig.data.tabsConfig.uniqueClass,
    el: svs.tabsConfig.data.tabsConfig.uniqueClass,
    scrollToSelected: true,
    showScrollbar: true,
    useScrollFaders: false,
    useScrollHelpers: false
  });
  if (typeof history.replaceState === 'function') {
    const originalReplaceState = history.replaceState;
    history.replaceState = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      originalReplaceState.apply(this, args);
      window.requestIdleCallback(() => {
        const newRoute = args[2];
        let activeIndex = 0;
        for (let i = links.length - 1; i >= 0; i--) {
          const currentLink = links[i];
          const index = newRoute.indexOf(currentLink.href);
          if (index > -1) {
            activeIndex = i;
            break;
          }
        }
        itemsMenu.setSelectedItemByIndex(activeIndex, true);
      });
    };
  }
}

 })(window);